import {Component, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup, NgForm, Validators} from "@angular/forms";
import {AlertController, LoadingController, ModalController, NavController, ToastController} from "@ionic/angular";
import {ActivatedRoute, Router} from "@angular/router";
import {ServerService} from "../service/server.service";
import {AdminService} from "../service/admin.service";
import {IntegrationService} from "../service/integration.service";
import {Constant} from "../shared/model/Constant";

@Component({
  selector: 'app-recharge',
  templateUrl: './recharge.page.html',
  styleUrls: ['./recharge.page.scss'],
})
export class RechargePage implements OnInit {

  @ViewChild('input', {static: false}) searchInput: { setFocus: () => void; };
  @ViewChild('form', {static: false}) ngForm: NgForm;

  operator: any;
  type: any = 0;
  product: any;
  price: any;
  form: FormGroup;
  recharge: any;
  selectedProvider: any;
  loading: any;

  constructor(public alertController: AlertController,
              private route: ActivatedRoute,
              public server: ServerService,
              public toastController: ToastController,
              private nav: NavController,
              public loadingController: LoadingController,
              private adminService: AdminService,
              private formBuilder: FormBuilder,
              private integrationService: IntegrationService,
              public modalController: ModalController,
              private router: Router
  ) {
    if (!localStorage.getItem(Constant.userId) || localStorage.getItem(Constant.userId) == undefined
      || localStorage.getItem(Constant.userId) == 'null') {
      this.nav.navigateRoot('/main');
    }

  }

  async ngOnInit() {
    this.loading = await this.loadingController.create({
      message: '',
      spinner: 'bubbles',
      duration: 30000
    });
    this.getProviderSelected();
    this.initForm();
  }


  getProviderSelected() {
    const provider = sessionStorage.getItem(Constant.rechargeProvider);
    this.selectedProvider = JSON.parse(provider);
    if (!this.selectedProvider) {
      this.router.navigate(['/select-product']);
    }
  }

  initForm() {
    this.form = this.formBuilder.group({
      number: ['', Validators.required],
      amount: ['', Validators.required],
      productCode: [this.selectedProvider.supplierCode, Validators.required]
    });
  }


  buyRecharge(value) {
    this.loading.present();
    value.userId = localStorage.getItem(Constant.userId);
    this.integrationService.buyRecharge(value).subscribe((res: any) => {
      this.recharge = res;
      this.presentToast(res.observation);
      this.form.reset();
      this.loading.dismiss();
    }, error => {
      this.presentToast(error.error.error.message);
      this.loading.dismiss();
    });
  }

  async presentToast(txt) {
    const toast = await this.toastController.create({
      message: txt,
      duration: 3000,
      position: 'top',
      mode: 'ios',
      color: 'dark'
    });
    toast.present();
  }

}

